
          import { defineNuxtPlugin } from "#imports";

          export default defineNuxtPlugin({
            name: 'sentry-client-config',
            async setup() {
              await import("/home/msservice/workspace/MAYBE/STG/STG-MAYBE-V3-FE/maybe-v3-fe-stg/sentry.client.config.ts")
            }
          });